import { format, parseISO } from "date-fns";
import { NUMERIC_DATE_TIME_FORMAT } from "@/react/datetime/constants";

/**
 * @param value ISO-formatted JS date time
 */
export const formatISODateTime = (value) => {
  const parsedDate = parseISO(value);
  return format(parsedDate, NUMERIC_DATE_TIME_FORMAT);
};
